/**
 * ギフトインデックス: コレクションタブ切り替え・モバイル横スクロールのインジケーター
 */
(function () {
  var MOBILE_MQ = '(max-width: 749px)';

  function updateGiftIndexScrollBar(ul) {
    if (!ul || ul.getAttribute('data-gift-index-scroller') == null) return;
    var comp = ul.closest('slider-component');
    var track = comp && comp.querySelector('[data-gift-index-scroll-track]');
    var fill = track && track.querySelector('.p-gift-index__scroll-fill');
    if (!track || !fill) return;

    var isMobile = window.matchMedia(MOBILE_MQ).matches;
    var max = ul.scrollWidth - ul.clientWidth;

    if (!isMobile || max <= 0) {
      track.hidden = true;
      return;
    }

    track.hidden = false;
    var vw = (ul.clientWidth / ul.scrollWidth) * 100;
    var left = (ul.scrollLeft / ul.scrollWidth) * 100;
    fill.style.width = vw + '%';
    fill.style.left = left + '%';
  }

  function bindGiftIndexScroller(ul) {
    if (!ul || ul.dataset.giftIndexScrollBound === 'true') return;
    ul.dataset.giftIndexScrollBound = 'true';

    function upd() {
      updateGiftIndexScrollBar(ul);
    }

    ul.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(upd);
      ro.observe(ul);
    }

    upd();
  }

  function refreshVisiblePanelScrollBars(group) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var panel = group.querySelector('[data-gift-index-panel]:not([hidden])');
        if (!panel) return;
        var sc = panel.querySelector('[data-gift-index-scroller]');
        if (sc) {
          sc.scrollLeft = 0;
          updateGiftIndexScrollBar(sc);
        }
      });
    });
  }

  function initGroup(group) {
    if (group.dataset.giftIndexBound === 'true') return;
    group.dataset.giftIndexBound = 'true';

    var tabs = group.querySelectorAll('[data-gift-index-tab]');
    var panels = group.querySelectorAll('[data-gift-index-panel]');
    if (!tabs.length || !panels.length) return;

    function activate(index) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (panel, i) {
        if (i === index) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
      refreshVisiblePanelScrollBars(group);
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activate(i);
      });
    });

    var initial = 0;
    tabs.forEach(function (tab, i) {
      if (tab.classList.contains('is-active')) initial = i;
    });
    activate(initial);
  }

  function initAll() {
    document.querySelectorAll('[data-gift-index-scroller]').forEach(bindGiftIndexScroller);

    document.querySelectorAll('[data-gift-index-root]').forEach(function (root) {
      root.querySelectorAll('[data-gift-index-group]').forEach(initGroup);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () {
    initAll();
  });
})();
